import { z } from 'zod';
import {
    CloverTerminalSaleLifecyclePayloadType,
    type CloverTerminalSaleLifecyclePayload,
    type CloverTerminalSaleRequestLifecyclePayload,
    type CloverTerminalSaleResponseLifecyclePayload,
} from '../../../types/ipg/clover/clover-terminal-sale-lifecycle.types';
import { CloverTerminalSaleRequestDetailsSchema } from './clover-terminal-sale.schemas';
import { CloverTerminalSaleResponseDetailsSchema } from './clover-terminal-sale-response.schemas';

export const CloverTerminalSaleRequestLifecyclePayloadSchema: z.ZodObject<{
    gateway_lifecycle_payload_type: z.ZodLiteral<
        typeof CloverTerminalSaleLifecyclePayloadType.REQUEST
    >;
    request_details: typeof CloverTerminalSaleRequestDetailsSchema;
}> = z.object({
    gateway_lifecycle_payload_type: z.literal(CloverTerminalSaleLifecyclePayloadType.REQUEST),
    request_details: CloverTerminalSaleRequestDetailsSchema,
}) satisfies z.ZodType<CloverTerminalSaleRequestLifecyclePayload>;

export const CloverTerminalSaleResponseLifecyclePayloadSchema: z.ZodObject<{
    gateway_lifecycle_payload_type: z.ZodLiteral<
        typeof CloverTerminalSaleLifecyclePayloadType.RESPONSE
    >;
    response_details: typeof CloverTerminalSaleResponseDetailsSchema;
}> = z.object({
    gateway_lifecycle_payload_type: z.literal(CloverTerminalSaleLifecyclePayloadType.RESPONSE),
    response_details: CloverTerminalSaleResponseDetailsSchema,
}) satisfies z.ZodType<CloverTerminalSaleResponseLifecyclePayload>;

export const CloverTerminalSaleLifecyclePayloadSchema: z.ZodType<CloverTerminalSaleLifecyclePayload> =
    z.discriminatedUnion('gateway_lifecycle_payload_type', [
        CloverTerminalSaleRequestLifecyclePayloadSchema,
        CloverTerminalSaleResponseLifecyclePayloadSchema,
    ]);
